// extracted by mini-css-extract-plugin
module.exports = {"hashLink":"Link_hashLink__sPeST","inactive":"Link_inactive__ai82B"};